import { Box } from '@mui/system';
import { GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';
import FlowStatusChip, { FlowStatus } from '../FlowStatusChip';

const FlowStatusCell: React.FC<GridRenderCellParams<boolean>> = ({ value }) => (
	<Box display="flex" flexGrow={1}>
		<FlowStatusChip status={value ? FlowStatus.disabled : FlowStatus.active} />
	</Box>
);

export default FlowStatusCell;
